import * as LucideIcons from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { JSX, Ref } from "react";

import { isSizePreset, sizeToCss } from "@frontend/styles";
import { SIZES } from "@frontend/styles/constants";

import type { IconProps } from "./Icon.types";
import { ICON_SIZES } from "./constants";

export function Icon({
  ref,
  name,
  size = "md",
  strokeWidth = 2,
  style,
  ...props
}: IconProps & { ref?: Ref<SVGSVGElement> }): JSX.Element {
  const Component = LucideIcons[name] as LucideIcon;

  const presetSize = isSizePreset(size, SIZES) ? ICON_SIZES[size] : undefined;

  const cssSize = presetSize === undefined ? sizeToCss(size) : undefined;

  return (
    <Component
      ref={ref}
      size={presetSize}
      strokeWidth={strokeWidth}
      style={cssSize ? { width: cssSize, height: cssSize, ...style } : style}
      {...props}
    />
  );
}
